var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"back-fade"}},[(_vm.visible)?_c('button',{staticClass:"page-back-btn",attrs:{"title":"返回"},on:{"click":_vm.goBack}},[_c('i',{staticClass:"el-icon-arrow-left"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }